import styled from '@emotion/styled'

const offerLinkWrapperBaseStyles = `
  display: block;
  width: 100%;
  text-decoration: none;

  /* TODO: (@search / @atlas) - relook line-height override when removing the default line-height on anchors */
  line-height: 1;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`

export const OfferLinkWrapper = styled.a`
  ${offerLinkWrapperBaseStyles}
`
export const LockedDealWrapper = styled.span`
  ${offerLinkWrapperBaseStyles}
`
